/**
 * The splash a signed-out visitor sees on a shared lobby link.
 *
 * The actual stash/peek/consume mechanism this screen's sign-in form drives
 * lives in ../lobby-invite-stash.ts, not here — see that module's own doc
 * for why it is separate. This file is only the screen: a placeholder
 * headline (see CLAUDE.md's copywriting rule) and the site's one sign-in
 * form, wired to stash the id it was given right before the OAuth redirect
 * fires.
 */
import { footer, pageHead } from "../chrome";
import { el } from "../dom";
import { stashLobbyInvite } from "../lobby-invite-stash";
import { signInForm } from "../signin-form";

/**
 * A one-time splash for a signed-out visitor who opened a shared lobby link:
 * sign in, then land back in the lobby they were invited to. The form's
 * onBeforeConnect stashes `matchId` immediately before the redirect;
 * router.ts's start() is what actually restores it on the way back.
 */
export function lobbyInviteScreen(matchId: string, error?: string): Node[] {
  const { form } = signInForm({
    error,
    onBeforeConnect: () => stashLobbyInvite(matchId),
  });

  return [
    pageHead(
      "You've been invited to join a lobby on lance.blue!",
      "Please sign in with your Atmosphere account first.",
    ),
    el("section", { className: "card" }, [form]),
    footer(),
  ];
}
